import { ILoyaltyContext as ILoyaltyContextInterface } from './loyalty-context';

export type ILoyaltyContext = ILoyaltyContextInterface;

export { LoyaltyContext, LoyaltyProvider, useLoyaltyContext } from './loyalty-context';
